import React from 'react';
import { Row, Col } from "react-bootstrap";
import Text from "../Text";
import Modal from '../Modal';
import Button from '../Button';
import Link from '../Link';

export default function SelectBusinessGroupModal({
	showCnpjsModal,
	onClose=() => {},
	groups = [],
}) {
	return (
		<Modal
			show={showCnpjsModal}
			handleClose={onClose}
			heading={
				<Text color="dark" type="header">
					CNPJ's Vinculados
				</Text>
			}
			body={
				<div>
					{groups.map((group, groupIndex) => (
						<div key={`group-${group.id}`}>
							<Row className="mb-3">
								<Col xs={12} className="mt-2">
									<Text type="small">
										<strong>{group.principal?.label}</strong>
									</Text>
								</Col>
							</Row>
							{group.persons && group.persons.length > 0 && (
								<Row className="mb-3">
									<Col xs={12}>
										<div
											style={{
												maxHeight: '300px',
												overflowY: 'auto',
											}}
										>
											{group.persons.map((person, i) => (
												<div
													key={`person-${person.id}`}
													style={{
														paddingBottom: '12px',
														marginBottom:
															i < group.persons.length - 1
																? '12px'
																: '0px',
														borderBottom:
															i < group.persons.length - 1
																? '1px solid #e0e0e0'
																: 'none',
													}}
												>
													<div className='d-flex'>
														<Link to={`/clientes/${person.id}`} target="_blank"  type="small">{person.label}</Link>
													</div>
												</div>
											))}
										</div>
									</Col>
								</Row>
							)}
						</div>
					))}
				</div>
			}
			footer={
				<Row style={{ justifyContent: 'flex-end' }}>
					<Button
						variant="primary"
						onClick={onClose}
						className="mr-2 mt-1 py-2"
					>
						<Text weight="500">Fechar</Text>
					</Button>
				</Row>
			}
		/>
	)
}